<template>
    <div class="product-item-small" :class="{ 'effect': effect, 'small': small }">
        <div class="product-item-in-small">
            <NuxtLink
                :to="product.url"
                @click="emit('product-clicked')"
                class="card h-100 product-item product-item-short p-0 border-0 d-flex flex-column text-center text-decoration-none"
            >

                <ProductBadges v-if="!small" :product="product" :absolute="true"/>
                <div
                    class="ratio ratio-1x1 product-thumb-header bg-black d-flex justify-content-center align-items-center position-relative w-100 flex-shrink-0 pb-2"
                    :class="{'small': small, 'py-3': !small}"
                >
                    <div class="product-thumb-img" :class="{'p-md-3': !small}">
                        <ProductImage :product="product" :small="false" />
                    </div>

                    <div class="position-absolute top-0 end-0 m-2 me-0">
                        <WatchlistButton :product_id="product.id" />
                    </div>
                </div>

                <div class="product-thumb-body p-3 pb-1 d-flex flex-column flex-grow-1 bg-grey" :class="{[bodyClass]: bodyClass}">
                     <span
                         class="card-title clamp-2 mb-2 fw-bold text-uppercase"
                         :title="product.name"
                     >
                        {{ product.name }}
                    </span>
                    <slot>
                        <div class="product-thumb-description">
                            <div class="col col-auto">
                                {{ weightStore.format(product.fine_weight) || ' ' }}
                                <template v-if="!small && !product.is_nos && product.availability.quantity > 0">
                                    <span class="mx-2">
                                    •
                                    </span>
                                    <ProductTotalAvailability v-if="!small" :product="product" />
                                </template>
                            </div>
                        </div>
                        <div class="py-3">
                            <ProductPriceTable :show-vat-in-separate-column="!small" :product="product" :use-small-tag="false" :show-premium="false" table-class="pb-0"/>

                            <div class="font-size-12">
                                <ProductPremiumLabel v-if="showPremium" :product="product"/>
                            </div>
                        </div>
                    </slot>

                    <div class="cart-action-container" :class="{'small': small}">
                        <CartButton v-if="product.shop_availability" :product="product" :small="small" :size="small ? 'sm' : 'lg'" @update-quantity="updateQuantity"/>
                        <NotifyButton v-else :product_id="product.id" :size="small ? 'sm' : 'lg'"/>
                    </div>
                </div>
            </NuxtLink>
        </div>
    </div>
</template>

<script setup>
const NotifyButton = defineAsyncComponent(() => import('~/components/Product/Buttons/NotifyButton.vue'));
const ProductImage = defineAsyncComponent(() => import('~/components/Product/ProductImage.vue'));
const WatchlistButton = defineAsyncComponent(() => import('~/components/Product/Buttons/WatchlistButton.vue'));
const CartButton = defineAsyncComponent(() => import("~/components/Product/Buttons/CartButton.vue"));
const ProductPriceTable = defineAsyncComponent(() => import('~/components/Product/ProductPriceTable.vue'));
const ProductPremiumLabel = defineAsyncComponent(() => import("~/components/Product/ProductPremiumLabel.vue"));
const ProductBadges = defineAsyncComponent(() => import("../Page/ProductBadges.vue"));
const ProductTotalAvailability = defineAsyncComponent(() => import("../ProductTotalAvailability.vue"));
import {useProductQuantityStore} from "../../../stores/ProductQuantityStore.js";

const weightStore = useWeightStore();

const props = defineProps({
    product: Object,
    effect: Boolean,
    small: Boolean,
    bodyClass: {
        type: String,
        default: 'text-start',
    },
    showPremium: {
        type: Boolean,
        default: true,
    },
})

const emit = defineEmits(['product-clicked']);

const updateQuantity = (quantity) => useProductQuantityStore().updateQuantity(props.product.id, quantity);

</script>
